import { parseItems } from './parsers/items';
import { toError } from './parsers/error';
export function initItems(settings, http) {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      albumId: folderId || null,
      pageSize: Math.min(options.paging.size || settings.itemsLimit, settings.itemsLimit),
      pageToken: options.paging.cursor
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/media`, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseItems).catch(toError);
  }
  return {
    list
  };
}